import React from 'react';
import Logo from '../logo_maxi.png';
import { ListGroupItem, Row, Col, Input } from 'reactstrap';

export default class Nav extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : '',
      usingThumbNails : true,
    };

    this.backClicked = this.backClicked.bind(this);

  }

  componentDidMount(){
  }

  backClicked(e){
    window.dataLayer.push({
      eventCategory: 'liste',
      eventAction: 'clicInterne',
      eventLabel: 'retourAccueil',
      event: 'genericGAEvent'
    });

    this.props.handler(e);
  }

  render () {
    let goBack = <a onClick={this.backClicked}
    style={{
      width:'93px',
      textDecoration:'none',
      marginLeft:"10px",
      color:'yellow',
      cursor:"pointer"
    }}>{"<Retour "}</a>

    return (
      <React.Fragment>
        <Col md="" style={{
          minHeight:"150px" ,
          marginTop:"30px"
        }}>

<div className="mainLogo" style={{
             display:"flex",
             position:"relative",
             paddingTop:"2%",
             paddingLeft:"2%"
      }}>
          <img src={Logo} alt="" style={{
            float:'left',
            width:"20%",
            minWidth:"110px",
            maxWidth:"200px",
            height: "auto",
            objectFit: "cover"
        }}/>
        {this.state.showBack &&
          <div style={{position:"absolute", bottom : -30}}>
            {goBack}
          </div>
        }


        <h3 id="playerTitle" style={{
          float:"left",
          textAlign:"left",
          fontWeight:"bold",
          marginTop:"15px",
          marginLeft:"10px"
        }}>
          VOTRE LISTE
          <br/>
          D'ÉPICERIE CHANTÉE !
        </h3>

        </div>

        <Row style={{
          width: '100%',
          textAlign: 'left'
        }}>
        {goBack}
            </Row>
        </Col>


      </React.Fragment>
    );
  }
}
